import { useEffect } from 'react';

interface PageMeta {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
}

const DEFAULTS = {
  title: 'CoffeeMates — Connect Over Coffee',
  description: 'Meet interesting people over coffee in Baku. Small groups, real conversations, every week.',
  image: 'https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=1200',
  url: 'https://coffeemates.biz',
};

const isBrowser = typeof document !== 'undefined';

function setMetaContent(selector: string, content: string) {
  if (!isBrowser) return;
  document.querySelector(selector)?.setAttribute('content', content);
}

function setTitle(title: string) {
  if (!isBrowser) return;
  document.title = title;
}

export function usePageMeta(meta: PageMeta) {
  useEffect(() => {
    if (!isBrowser) return;

    if (meta.title) {
      setTitle(meta.title);
      setMetaContent('meta[property="og:title"]', meta.title);
      setMetaContent('meta[name="twitter:title"]', meta.title);
    }
    if (meta.description) {
      setMetaContent('meta[property="og:description"]', meta.description);
      setMetaContent('meta[name="twitter:description"]', meta.description);
    }
    if (meta.image) {
      setMetaContent('meta[property="og:image"]', meta.image);
      setMetaContent('meta[name="twitter:image"]', meta.image);
    }
    if (meta.url) {
      setMetaContent('meta[property="og:url"]', meta.url);
    }

    return () => {
      setTitle(DEFAULTS.title);
      setMetaContent('meta[property="og:title"]', DEFAULTS.title);
      setMetaContent('meta[name="twitter:title"]', DEFAULTS.title);
      setMetaContent('meta[property="og:description"]', DEFAULTS.description);
      setMetaContent('meta[name="twitter:description"]', DEFAULTS.description);
      setMetaContent('meta[property="og:image"]', DEFAULTS.image);
      setMetaContent('meta[name="twitter:image"]', DEFAULTS.image);
      setMetaContent('meta[property="og:url"]', DEFAULTS.url);
    };
  }, [meta.title, meta.description, meta.image, meta.url]);
}
